import { Map } from "immutable";
import { useCallback, useEffect, useRef } from "react";
import { WrappedFieldProps } from "redux-form";

import { SchoolOption } from "seneca-common/features/schools/service";

import SchoolsDropdownComponent from "./SchoolsDropdownComponent";

type Props = WrappedFieldProps & {
  isDisabled?: boolean;
};

export default function SchoolsDropdown(props: Props) {
  const {
    input: { name, onChange, value: immutableValue, onBlur },
    meta: { error, submitFailed },
    isDisabled
  } = props;

  const value = immutableValue && immutableValue.toJS();

  // Addresses onBlur issue on mobile https://github.com/JedWatson/react-select/issues/2692
  const valueRef = useRef<SchoolOption | undefined>(value);

  useEffect(() => {
    valueRef.current = value;
  }, [value]);

  const handleChange = useCallback(
    (option: SchoolOption) => {
      valueRef.current = option;
      onChange(Map(option));
    },
    [onChange]
  );

  const handleBlur = useCallback(
    () => onBlur(valueRef.current ? Map(valueRef.current) : valueRef.current),
    [onBlur]
  );

  return (
    <SchoolsDropdownComponent
      name={name}
      value={value}
      isDisabled={isDisabled}
      onChange={handleChange}
      onBlur={handleBlur}
      error={error}
      showError={submitFailed && !!error}
    />
  );
}
